"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  padding: 5px 15px;\n  border-radius: 15px;\n  background-color: ", ";\n  color: ", ";\n"], ["\n  ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  padding: 5px 15px;\n  border-radius: 15px;\n  background-color: ", ";\n  color: ", ";\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _buoyTheme = require("buoy-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Tag = _styledComponents2.default.span.withConfig({
  displayName: "Tag",
  componentId: "jdn4l5-0"
})(_templateObject, (0, _buoyTheme.fontSize)("label"), _buoyTheme.fontFamily, _buoyTheme.fontWeight.regular, function (props) {
  return _buoyTheme.colors[props.tagColor] || props.tagColor;
}, function (props) {
  return _buoyTheme.colors[props.textColor] || props.textColor;
});

Tag.propTypes = {
  tagColor: _propTypes2.default.string,
  textColor: _propTypes2.default.string
};

Tag.defaultProps = {
  tagColor: "purple",
  textColor: "white"
};

exports.default = Tag;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-tag/dist/components/Tag.js
// module id = 231
// module chunks = 168707334958949